import React from 'react';
import { TFunction } from 'i18next';

import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import { INotificationTemplateTranslation } from '../../../../types/interfaces/notification-admin';
import { NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS } from './notificationTemplateDetailTranslationsTableColumns';

function bodyPreview(body: string, maxLen = 80) {
  if (body.length <= maxLen) return body;
  return `${body.slice(0, maxLen)}…`;
}

export function getNotificationTemplateDetailTranslationsCellReducers(
  _t: TFunction,
  classes: { actions?: string },
  opts: { canMutate: boolean; canDelete: boolean },
  langLabel: (languageId: string) => string,
  onEdit: (row: INotificationTemplateTranslation) => void,
  onDelete: (row: INotificationTemplateTranslation) => void,
) {
  const base = [
    {
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.LANGUAGE,
      cellReducer: (row: INotificationTemplateTranslation) => (
        <div>{langLabel(row.languageId)}</div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.TITLE,
      cellReducer: (row: INotificationTemplateTranslation) => (
        <div>{row.title}</div>
      ),
    },
    {
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.BODY,
      cellReducer: (row: INotificationTemplateTranslation) => (
        <div>{bodyPreview(row.body)}</div>
      ),
    },
  ];
  if (opts.canMutate || opts.canDelete) {
    base.push({
      id: NOTIFICATION_TEMPLATE_TRANSLATION_COLUMN_IDS.ACTIONS,
      cellReducer: (row: INotificationTemplateTranslation) => (
        <div className={classes.actions}>
          {opts.canMutate && (
            <EditActionButton
              onClick={(e) => {
                e.stopPropagation();
                onEdit(row);
              }}
            />
          )}
          {opts.canDelete && (
            <DeleteActionButton
              onClick={(e) => {
                e.stopPropagation();
                onDelete(row);
              }}
            />
          )}
        </div>
      ),
    });
  }
  return base;
}
